import { render } from "./AvatarSelect.vue?vue&type=template&id=1dbf5f7e&ts=true"
import script from "./AvatarSelect.vue?vue&type=script&lang=ts"
export * from "./AvatarSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__